import React, { FC, useCallback } from 'react';
import { Body, useModal } from '@sumup/circuit-ui';
import { ChevronDown } from '@sumup/icons';
import { useTranslation } from 'next-i18next';

import {
  SectionsListContainer,
  SectionsListTitle,
  MobileTrigger,
  MobileComponent,
} from '../styledComponents';
import SectionTypeList from '../SectionTypeList';

import { SectionTree, SectionTypeTree } from 'types/common';

type MobileSectionsListProps = {
  currentSection?: string;
  isPos?: boolean;
  sectionTree: SectionTree;
  sectionTypeTree: SectionTypeTree;
};

const MobileSectionsList: FC<MobileSectionsListProps> = ({
  currentSection = '',
  isPos = false,
  sectionTree = {},
  sectionTypeTree = {},
}) => {
  const { t } = useTranslation();
  const { setModal } = useModal();

  const ModalComponent = useCallback(
    () => (
      <MobileComponent>
        {Object.keys(sectionTypeTree).map((sectionType) => (
          <SectionsListContainer span="12" skip="0" key={sectionType}>
            {isPos ? null : (
              <SectionsListTitle size="one" variant="highlight">
                {t(`common.browse_by.${sectionType.toLowerCase()}`)}
              </SectionsListTitle>
            )}
            <SectionTypeList
              sectionTree={sectionTree}
              sectionType={sectionType}
              currentSection={currentSection}
              sectionTypeTree={sectionTypeTree}
              isPos={isPos}
            />
          </SectionsListContainer>
        ))}
      </MobileComponent>
    ),
    [currentSection, isPos, sectionTree, sectionTypeTree, t],
  );

  const showMobileSectionList = () => {
    setModal({
      closeButtonLabel: 'Close',
      children: <ModalComponent />,
    });
  };

  const showSectionList = () => showMobileSectionList();

  return (
    <MobileComponent>
      <Body size="two">{t('section_list.selector_title')}</Body>
      <MobileTrigger onClick={() => showSectionList()} type="button">
        <Body size="one">
          {currentSection
            ? sectionTree[currentSection]?.sectionTitle
            : `${t('section_list.selector_placeholder')}`}
        </Body>
        <ChevronDown />
      </MobileTrigger>
    </MobileComponent>
  );
};

export default MobileSectionsList;
